import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ShieldCheck } from "@phosphor-icons/react";

export default function Footer() {
  const [licenseCount, setLicenseCount] = useState(7);
  useEffect(() => {
    api.get("/licenses").then((r) => setLicenseCount((r.data.licenses || []).length)).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="border-t border-exodus-border mt-32 px-6 lg:px-12 py-12 bg-exodus-bg">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
        <div>
          <p className="font-display text-3xl gold-text">EXODUS</p>
          <p className="eyebrow text-exodus-muted mt-1">Life &amp; Wealth</p>
          <p className="text-sm text-exodus-muted mt-6 max-w-xs leading-relaxed">
            A structured advisory practice for IUL and Annuity strategies. Built for families who want to inherit wealth — not a tax bill.
          </p>
        </div>
        <div>
          <p className="eyebrow mb-4">Practice</p>
          <ul className="text-sm space-y-2 text-exodus-muted">
            <li>Indexed Universal Life</li>
            <li>Fixed &amp; Indexed Annuities</li>
            <li>Legacy &amp; Estate Strategy</li>
            <li>401(k) Rollover Strategy</li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">Explore</p>
          <ul className="text-sm space-y-2 text-exodus-muted">
            <li><Link to="/learn" className="hover:text-exodus-gold transition-colors">Education Library</Link></li>
            <li><Link to="/series" className="hover:text-exodus-gold transition-colors">Series Library</Link></li>
            <li><Link to="/calculator" className="hover:text-exodus-gold transition-colors">Tax-Free Calculator</Link></li>
            <li><Link to="/quiz" className="hover:text-exodus-gold transition-colors">Find My Fit</Link></li>
            <li><Link to="/results" className="hover:text-exodus-gold transition-colors">Public Results Board</Link></li>
            <li><Link to="/concierge" className="hover:text-exodus-gold transition-colors">Concierge</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">Compliance</p>
          <Link
            to="/credentials"
            data-testid="footer-credentials-link"
            className="inline-flex items-center gap-2 text-xs text-exodus-gold border border-exodus-gold/40 px-3 py-2 mb-4 hover:bg-exodus-gold hover:text-exodus-bg transition-colors"
          >
            <ShieldCheck size={14} />
            Licensed in {licenseCount} states · Verify
          </Link>
          <p className="text-xs text-exodus-muted leading-relaxed">
            EXODUS LIFE &amp; WEALTH is a brand operated by a licensed independent insurance advisor. All products are issued by third-party carriers. Illustrations are projections, not guarantees. This site is for informational purposes and does not constitute tax, legal, or investment advice.
          </p>
          <Link to="/privacy" data-testid="footer-privacy-link" className="text-xs gold-text hover:underline mt-3 inline-block">
            Privacy Policy →
          </Link>
          <span className="text-xs text-exodus-muted mx-2">·</span>
          <Link to="/support" data-testid="footer-support-link" className="text-xs gold-text hover:underline mt-3 inline-block">
            Support &amp; Contact →
          </Link>
        </div>
      </div>
      <p className="text-xs text-exodus-muted text-center mt-10">© {new Date().getFullYear()} EXODUS LIFE &amp; WEALTH. All rights reserved.</p>
    </footer>
  );
}
